import { ROOT_PATH, WORDPRESS_URL } from './paths';

export const getReactLink = (wplink) =>
    wplink.replace(WORDPRESS_URL, ROOT_PATH);
